import * as React from 'react';

import { plural } from '@cian/utils';

import { INewbuilding, INewbuildingFeatures } from '../../types/newbuilding';
import { NewbuildingFeature } from './NewbuildingFeature';
import {
  trackBuildingProgressFeatureClick,
  trackReviewsFeatureClick,
  trackMVKFeatureClick,
  trackTourFeatureClick,
} from '../../actions/analytics';

import * as styles from './NewbuildingFeatures.css';

interface INewbuildingFeaturesProps {
  newbuilding: INewbuilding;
}

export class NewbuildingFeatures extends React.PureComponent<INewbuildingFeaturesProps> {
  public render() {
    const { newbuilding } = this.props;

    if (!newbuilding.newbuildingFeatures && !newbuilding.hasTour) {
      return null;
    }

    const { hasTour = false, newbuildingFeatures = {} as INewbuildingFeatures } = newbuilding;
    const { reviewsCount = 0, hasMVK = false, hasProgressOfConstructions = false } = newbuildingFeatures;

    return (
      <div className={styles['container']}>
        {!!hasProgressOfConstructions && (
          <NewbuildingFeature
            type="progressOfConstructions"
            title="Ход строительства"
            url={`${newbuilding.url}hod-stroitelstva/`}
            onClick={trackBuildingProgressFeatureClick}
          />
        )}
        {!!reviewsCount && (
          <NewbuildingFeature
            type="featureReviews"
            title={`${reviewsCount} ${plural(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`}
            url={`${newbuilding.url}otzyvy/`}
            onClick={trackReviewsFeatureClick}
          />
        )}
        {hasMVK && (
          <NewbuildingFeature
            type="featureMvk"
            title="Интерактивный план"
            url={`${newbuilding.url}#map`}
            onClick={trackMVKFeatureClick}
          />
        )}
        {hasTour && (
          <NewbuildingFeature
            type="featureTour"
            title="3D-тур"
            url={`${newbuilding.url}#layouts`}
            onClick={trackTourFeatureClick}
          />
        )}
      </div>
    );
  }
}
